import { useFloating, useInteractions } from '@floating-ui/react';
import { useFloatingMenu } from 'articleEditor/hooks/useFloatingMenu';
import { MyVideoEmbedElement } from 'lib-knowledge-document-structure/plateTypes';
import { RenderElementProps } from 'lib-knowledge-document-structure/slate/react';

import VideoBlockPlaceholder from './videoBlockPlaceholder';
import VideoBlockValue from './videoBlockValue';
import { VideoPickerUploadMenu } from './videoPickerEmbedMenu';

export type VideoBlockProps = RenderElementProps & {
  element: MyVideoEmbedElement;
};

export type UploadFormProps = {
  uploadMenuGetReferenceProps: ReturnType<
    typeof useInteractions
  >['getReferenceProps'];
  openUploadMenu: () => void;
  uploadRef: ReturnType<typeof useFloating>['refs']['setReference'];
};

function VideoBlock({
  element,
  attributes,
  children,
}: VideoBlockProps): JSX.Element {
  const {
    showFloatingMenu: showUploadMenu,
    floatingResult,
    openFloatingMenu: openUploadMenu,
    closeFloatingMenu: closeUploadMenu,
    floatingMenuGetReferenceProps: uploadMenuGetReferenceProps,
    getFloatingMenuProps,
  } = useFloatingMenu();

  return (
    <div>
      {element.url ? (
        <VideoBlockValue
          element={element}
          attributes={attributes}
          openUploadMenu={openUploadMenu}
          uploadRef={floatingResult.refs.setReference}
          uploadMenuGetReferenceProps={uploadMenuGetReferenceProps}
        >
          {children}
        </VideoBlockValue>
      ) : (
        <VideoBlockPlaceholder
          element={element}
          attributes={attributes}
          openUploadMenu={openUploadMenu}
          uploadRef={floatingResult.refs.setReference}
          uploadMenuGetReferenceProps={uploadMenuGetReferenceProps}
        >
          {children}
        </VideoBlockPlaceholder>
      )}

      <VideoPickerUploadMenu
        element={element}
        closeUploadMenu={closeUploadMenu}
        floatingProps={{
          ...floatingResult,
          isOpen: showUploadMenu,
        }}
        getFloatingMenuProps={getFloatingMenuProps}
      />
    </div>
  );
}

export default VideoBlock;
